import styled from 'styled-components';
import { useDispatch } from 'src/store/store';
import i18n from 'src/utils/translate';
import Button from 'src/components/buttons/button';
import { titleSmall } from 'styles-js/mixins/typography';
import { showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';

export default function VisitorLoginPrompt() {
  const dispatch = useDispatch();

  return (
    <Container className="results-post">
      <Text>{i18n.t('Want to take advantage of all our features? Just log in!')}</Text>
      <ButtonContainer>
        <StyledButton
          type="secondary"
          onClick={() => {
            trackFootfallEvent(Event.Clicked, {
              clickType: 'login',
              clickMetadata: { section: Section.CommunityPosts, element: Element.VisitorPrompt },
            });
            dispatch(showLoginModal());
          }}
        >
          {i18n.t('Log in')}
        </StyledButton>
        <OrText>{i18n.t(' or ')}</OrText>
        <StyledButton
          onClick={() => {
            trackFootfallEvent(Event.Clicked, {
              clickType: 'sign-up',
              clickMetadata: { section: Section.CommunityPosts, element: Element.VisitorPrompt },
            });
            dispatch(showSignupModal());
          }}
        >
          {i18n.t('Join')}
        </StyledButton>
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.div`
  background-color: ${props => props.theme.colorBlueBackground};
  padding: 20px;
`;

const Text = styled.div`
  ${titleSmall};
  text-align: center;
  margin-bottom: 10px;
`;

const OrText = styled.div`
  margin: auto 0;
  width: 10%;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  width: 30%;
`;
